import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select, Checkbox } from "antd";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";

import { crud } from "@/redux/crud/actions";
import { selectListItems, selectUpdatedItem } from "@/redux/crud/selectors";
import axios from "axios";
import { useParams } from "react-router-dom";
import HeaderContent from "@/layout/HeaderContent";
import { useDispatch, useSelector } from "react-redux";
import Loading from "@/components/Loading";


export default function UserEdit() {
    let { id } = useParams();
    let [data, setData] = useState([]);
    const dispatch = useDispatch();
    const { current, isLoading, isSuccess } = useSelector(selectUpdatedItem);

    useEffect(() => {
        axios(`${API_BASE_URL}user/read/${id}`)
            .then(res => {
                setData(res.data.result)
            })
            .catch(err => {
             
                
            })
    }, [isSuccess]);
    const [form] = Form.useForm();
    useEffect(() => {
        if (isSuccess) {
            form.resetFields();
            dispatch(crud.resetAction("update"));
        }
    }, [isSuccess]);
    form.setFieldsValue(
        {
            fname: data.fname,
            lname: data.lname,
            email: data.email,
            phone: data.phone,
            country: data.country,
            city: data.city,
            block_status: data.block_status
        }
    );
    const onFinish = (values) => {
        
        
    };
    const onSubmit = () => {
        dispatch(crud.update("user", id, form.getFieldValue()));
    }
    return (
        <>
            <HeaderContent />
            <div className="user_edit_form">

                <Loading isLoading={isLoading}>
                    <Form form={form} name="control-hooks" onFinish={onFinish}>
                        <Form.Item
                            label="First Name"
                            name="fname"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input first name!",
                                },
                            ]}
                            style={{
                                display: "inline-block",
                                width: "calc(50%)",
                                paddingRight: "5px",
                            }}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Last Name"
                            name="lname"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input last name!",
                                },
                            ]}
                            style={{
                                display: "inline-block",
                                width: "calc(50%)",
                                paddingRight: "5px",
                            }}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your email!",
                                },
                            ]}
                        // style={{
                        //   display: "inline-block",
                        //   width: "calc(50%)",
                        //   paddingLeft: "5px",
                        // }}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Mobile"
                            name="phone"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input mobile!",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Country"
                            name="country"
                            rules={[
                                // {
                                //   type: "email",
                                //   message: "The input is not valid E-mail!",
                                // },
                                {
                                    required: true,
                                    message: "Please input your E-mail!",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="City"
                            name="city"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Input City",
                                },

                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item label="Block Status" name="block_status">
                            <Select>
                                <Select.Option value={true}>Block</Select.Option>
                                <Select.Option value={false}>Unblock</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item type="primary" htmlType="submit" onClick={onSubmit} >
                            <Button>Update</Button>
                        </Form.Item>
                    </Form>
                </Loading>
            </div>
        </>
    );
}
